import script from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./DropdownMenu.vue?vue&type=style&index=0&id=55971f19&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55971f19"]])

export default __exports__